import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils.ts'
import { Tip } from '@/components/common/tip/Tip.tsx'
import { useTranslation } from 'react-i18next'

export type LoadingIndicatorT = 'fullScreen' | 'nested' | 'syncing'

type PropsT = {
  className?: string
  iconClassName?: string
  type?: LoadingIndicatorT
  syncingTipContent?: string
}

const LoadingIndicator = ({ className, iconClassName, type, syncingTipContent }: PropsT) => {
  const { t } = useTranslation()
  let defaultClassName = ``

  switch (type) {
    case 'fullScreen':
      defaultClassName = `h-screen w-screen`
      break

    case 'nested':
      defaultClassName = `fixed left-0 top-0 md:pl-[var(--sidebar-width)]`
      break
  }

  const Indicator = () => (
    <div
      data-cy={'loading-indicator'}
      className={cn(
        `pointer-events-none flex h-full w-full grow items-center justify-center`,
        className,
        defaultClassName,
      )}
    >
      <Loader2 className={cn(`size-[40px] animate-spin`, iconClassName)} />
    </div>
  )

  if (type !== 'syncing') {
    return <Indicator />
  }

  return (
    <Tip
      contentClassName={'max-w-[180px]'}
      side={'bottom'}
      children={<Indicator />}
      content={syncingTipContent ?? t('project.common.syncGeneric')}
    />
  )
}

export default LoadingIndicator
